const mapActiveGroupUsersToIds = (groupUsers) => groupUsers.filter(({ active }) => active).map(({ id }) => id);

export default mapActiveGroupUsersToIds;
